<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">关于凯纳</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeWenHua')">企业文化</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeZhanShi')">企业展示</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('FaZhanLiCheng')">发展历程</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZiZhiRongYu')">资质荣誉</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ChengGongAnLi')">典型案例</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YuanGongFengCai')">员工风采</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ChanPinJiYingYongShiPin')">产品及应用视频</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <div id="video_list">
                        <ul>
                            <li v-for="(article, index) in article_list">
                                <div class="video" @click.stop="article_view(article.id)">
                                    <span class="icon icon_play"></span>
                                    <img :src="img_address+article.webIco" :onerror="defaultImg" />
                                    <div class="video_title">{{ article.webTitle }}</div>
                                </div>
                                
                            </li>
                        </ul>

                    </div>
                    <!-- <div id="article_list">
                        <ul>
                            <li v-for="(article, index) in article_list" :key="index" :id="article.id"><span class="title"><a href="javascript:void(0);"><i class="icon icon_arrow"></i>{{ article.webTitle }}</a></span><span class="date">{{ article.createTime }}</span></li>
                        </ul>
                    </div> -->
                    <div class="page">
                        <span>总共 {{ total_page }} 页，当前第 {{ pageNum }} 页</span>
                        <a href="javascript:void(0);" @click.stop="page('first')">首页</a>
                        <a href="javascript:void(0);" @click.stop="page('pre')" v-if="page_pre == 1">上一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">上一页</a>
                        <a href="javascript:void(0);" @click.stop="page('next')" v-if="page_next == 1">下一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">下一页</a>
                        <a href="javascript:void(0);" @click.stop="page('last')">尾页</a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { ChanPinJiYingYongShiPin } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '产品及应用视频',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            article_list: '',

            img_address:'http://www.corner.com.cn',

            defaultImg: 'this.src="' + require('../assets/img/default.jpg') + '"',

            //翻页
            pageNum: 1, //当前页
            pageSize: 10, //每页显示数
            total : 0, //总数据

            total_page : '', //总页数
            page_pre : 0, //上一页
            page_next : 0, //下一页
            // jump_page : '', //跳转页面默认值
            
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.ChanPinJiYingYongShiPin_data( this.pageNum, this.pageSize );
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        article_view( id ) {  //带uuid跳转详情页面
            this.$router.push({
                path: "ArticleView",
                query: { id: id,webType: 111 },
            });
        },
        page(e) {
            //分页参数
            if( e == "first" ){
                //首页
                this.ChanPinJiYingYongShiPin_data(
                    1,
                    this.pageSize,
                );
            } else if ( e == "pre" ) {
                //上一页
                this.ChanPinJiYingYongShiPin_data(
                    this.pageNum - 1,
                    this.pageSize,
                );
            } else if ( e == "next" ) {
                //下一页
                this.ChanPinJiYingYongShiPin_data(
                    this.pageNum + 1,
                    this.pageSize,
                );
            } else if( e == "last" ){
                //尾页
                this.ChanPinJiYingYongShiPin_data(
                    this.total_page,
                    this.pageSize,
                );
            };
        },
        ChanPinJiYingYongShiPin_data( pageNum, pageSize ){ //文章分类显示
            ChanPinJiYingYongShiPin({
                pageNum : pageNum, //当前是第几页
                pageSize : pageSize, //每页显示多少条
            }).then((res) => {
                //console.log( res );
                this.article_list = res.rows;
                //翻页
                this.pageNum = pageNum; //当前页
                this.total = res.total; //总数据

                this.total_page = Math.ceil( res.total / this.pageSize );

                if( this.pageNum < this.total_page && this.pageNum == 1){
                    this.page_pre = 0;
                    this.page_next = 1;
                } else if ( this.pageNum == this.total_page && this.pageNum !== 1 ) {
                    this.page_pre = 1;
                    this.page_next = 0;
                } else if ( this.pageNum == this.total_page && this.total_page == 1 ) {
                    this.page_pre = 0;
                    this.page_next = 0;
                }else{
                    this.page_pre = 1;
                    this.page_next = 1;
                };

            });
        },
    },
};
</script>
<style lang="less" scoped>
#video_list{
    display: block;
    margin:20px 30px;
    zoom:1;
    overflow: auto;

    li{
        float: left;
        width:33.333%;
        margin: 10px 0px;
        text-align: center;

        .video{
            position: relative;
            width: 300px;
            height: 200px;
            margin: 0px auto;
            overflow: hidden;
            border-radius: 10px;
            background-color: #f4f4f4;
            cursor: pointer;

            img{
                display: flex;
                width: 100%;
                height: auto;
                background-color: #000;
            }

            span{
                position: absolute;
                z-index:9;
                left: 37%;
                top: 25%;
                border-radius: 100px;
                width:80px;
                height: 80px;
                background-size: 80px 160px;
                background-position: center top;
                opacity: 0.5;
            }
            .video_title{
                position: absolute;
                left:0px;
                bottom:0px;
                width:100%;
                height:40px;
                line-height: 40px;
                font-size:12px;
                color:#fff;
                background-color: rgba(0,0,0,1);
            }
        }
        .video:hover{
            box-shadow: 3px 3px 5px rgba(0,0,0,0.5);
            img{
                animation: video_img_hover 0.3s linear forwards;

                @keyframes video_img_hover {
                    0% {
                        filter: blur(0px);
                        opacity: 1;
                    }
                    50% {
                        filter: blur(5px);
                        opacity: 0.2;
                    }
                    100% {
                        filter: blur(10px);
                        opacity: 0.8;
                    }
                }
            }
            span{
                opacity: 1;
                animation: video_span_hover 0.3s linear forwards;
                @keyframes video_span_hover {
                    0% {
                        opacity: 0.5;
                        top: 25%;
                    }
                    40% {
                        opacity: 0.1;
                        top: 20%;
                        box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);
                    }
                    100% {
                        opacity: 1;
                        top: 25%;
                        box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);
                    }
                }
            }
        }
        
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/ChanPinJiYingYongShiPin.vue